import React, { memo } from "react";
import Lozenge from "@atlaskit/lozenge";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import styles from "./StorageStats.module.css";
import useFetch from "../../../hooks/use-fetch";

const StorageStats = () => {
  const url = `api/dashboard/widget/storage-stats`;
  const { data: storageStatDetails, isLoading, error } = useFetch(url);
  const {
    snapshotsCount = 0,
    attachmentsSizeGigaBytes = 0,
    totalSize = "250 GB",
    issuesCount = 0,
  } = {
    ...storageStatDetails,
  };

  if (isLoading) {
    return (
      <div className={styles.headerCardContainer}>
        <div className={styles.headerCardTitle}>Storage stats</div>
        <div className={styles.headerCardBody}>
          <div className={styles.headerCardField}>
            <Skeleton
              width={"150px"}
              count={1}
              baseColor="lightgrey"
              height={"10px"}
            />
          </div>
          <div className={styles.headerCardField}>
            <Skeleton
              width={"150px"}
              count={1}
              baseColor="lightgrey"
              height={"10px"}
            />
          </div>
          <div className={styles.headerCardField}>
            <Skeleton
              width={"150px"}
              count={1}
              baseColor="lightgrey"
              height={"10px"}
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.headerCardContainer}>
      <div className={styles.headerCardTitle}>Storage stats</div>
      {!error && storageStatDetails ? (
        <div className={styles.headerCardBody}>
          <div className={styles.headerCardField}>
            <p className={styles.alignleft}>Snapshots:&nbsp;</p>
            <div className={styles.alignleft}>
              <Lozenge appearance="inprogress" style={{ padding: "20px" }}>
                {snapshotsCount}
              </Lozenge>
            </div>
          </div>
          <div className={styles.headerCardField}>
            <p className={styles.alignleft}>Attachment storage :</p>
            <div className={styles.alignleft}>
              <Lozenge appearance="inprogress" style={{ padding: "20px" }}>
                {attachmentsSizeGigaBytes}&nbsp;GB out of &nbsp;
                {totalSize}
              </Lozenge>
            </div>
          </div>
          <div className={styles.headerCardField}>
            <p className={styles.alignleft}>
              Issues count (last backup):&nbsp;
            </p>
            {
              <div className={styles.alignleft}>
                <Lozenge appearance="inprogress" style={{ padding: "20px" }}>
                  {issuesCount ? issuesCount : 0}
                </Lozenge>
              </div>
            }
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default memo(StorageStats);
